import { type, clone } from 'ramda';
import { getPathRegex } from '../../utils/paths';
import { getNamedParamFromProps } from '../../utils/props';

export const getCurrentStep = (config, props, { pathOverride = null } = {}) => {
  const stepPath = pathOverride || getNamedParamFromProps(props.appPath, props);
  let currentIndex = 0;
  // when stepPath is null, we don't need to check all paths for a match because it will never find
  // any, we then later fallback to an appropriate route if the path is null
  let current = !stepPath
    ? stepPath
    : config.steps.find(({ path }, i) => {
        const [re = null] = getPathRegex(path);
        currentIndex = i;
        return re !== null && re.exec(stepPath);
      });

  if (!current) {
    // if the config has a fallback path, we dont want to return the first step, but rather
    // redirect to a different URL
    if (config.stepNotFoundPath) {
      return null;
    }
    currentIndex = 0;
    current = config.steps[0];
  }

  const stepForReturn = clone(current);
  if (stepForReturn.extraProps) {
    Object.keys(stepForReturn.extraProps).forEach(key => {
      if (
        type(stepForReturn.extraProps[key]) === 'String' &&
        Object.prototype.hasOwnProperty.call(props, stepForReturn.extraProps[key])
      ) {
        stepForReturn.extraProps[key] = props[stepForReturn.extraProps[key]];
      }
    });
  }
  stepForReturn.index = currentIndex;

  return stepForReturn;
};
